import { siteConfig } from "@/configs/siteConfig";

import { siteState } from "@/modules/siteState/siteStateGetter";

import { lottieAnimation } from "@/modules/animations/lottieAnimation";
import { typingAnimation } from "@/modules/animations/typingAnimation";

const props = {
  setDelaySel: ".js-anime", // カンマ区切りで複数指定

  pageLoad: {
    className: "is-pageLoad",
    delay: siteState.dataPage === "home" ? 200 : 100,
  },

  anime: {
    triggerClassName: "js-anime",
    actClassName: "is-anime",
    rootMargin: "-20% 0%",
  },
} as const;

const state = {
  observer: null as IntersectionObserver | null,
};

export const animationManager = {
  init() {
    this.setDataDelay();
  },

  load() {
    if (siteState.splashEl) {
      siteState.splashEl.classList.add(siteConfig.class.act);
    }

    setTimeout(() => {
      document.documentElement.classList.add(props.pageLoad.className);

      this.applyObserver();
      // lottieAnimation.init();
      // typingAnimation.init();
      //
    }, props.pageLoad.delay);
  },

  reset() {
    this.cleanupObserver();

    // lottieAnimation.reset();
    // typingAnimation.reset();
  },

  setDataDelay() {
    const setDelayEls = Array.from(document.querySelectorAll(`${props.setDelaySel}`)) as HTMLElement[];
    setDelayEls.forEach((setDelayEl) => {
      const delay = Number(setDelayEl.dataset.delay);
      if (!isNaN(delay)) {
        setDelayEl.style.transitionDelay = `${delay}ms`;
      }
    });
  },

  applyObserver() {
    this.cleanupObserver();

    const observer = this.createObserver();
    state.observer = observer;

    const animeEls = Array.from(document.querySelectorAll(`.${props.anime.triggerClassName}`)) as HTMLElement[];
    animeEls.forEach((animeEl) => {
      observer.observe(animeEl);
    });
  },

  createObserver() {
    return new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          const targetEl = entry.target as HTMLElement;
          targetEl.classList.add(props.anime.actClassName);
          observer.unobserve(targetEl);
        });
      },
      {
        rootMargin: props.anime.rootMargin,
        threshold: 0,
      }
    );
  },

  cleanupObserver() {
    state.observer?.disconnect();
    state.observer = null;
  },
};
